import {
  faCreditCard,
  faMobileAlt,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef, useState } from "react";
// import { useNavigate } from 'react-router-dom'

const PaymentMethod = () => {
  const [activePaymentMethod, setActivePaymentMethod] = useState("card");
  const [kpaytimeLeft, setKpayTimeLeft] = useState(60);
  const [ayapayTimeLeft, setAyapayTimeLeft] = useState(60);
  const kpayTimerRef = useRef(null);
  const ayapayTimerRef = useRef(null);
  // const navigate = useNavigate()

  const paymentMethods = [
    {
      id: "card",
      icon: faCreditCard,
      title: "credit/Debit Card",
      description: "Visa, Mastercard, etc",
    },
    {
      id: "kpay",
      icon: faMobileAlt,
      title: "KPay",
      description: "Mobile Payment",
    },
    {
      id: "ayapay",
      icon: faUniversity,
      title: "AYA Pay",
      description: "Bank Transfer",
    },
  ];

  const subscriptionDetails = [
    { label: "Plan", value: "Standard" },
    { label: "Billing Cycle", value: "Monthly" },
    { label: "Feature", value: "XXXXXX" },
    { label: "Cost", value: "MMK 99,000" },
    { label: "Tax", value: "MMK 9,900" },
    { label: "Total Cost", value: "MMK 108,900" },
    { label: "Started Date: 01/06/2023", value: "Expire Date: 01/07/2023" },
  ];

  const startQrTimer = (type) => {
    if (type === "kpay") {
      clearInterval(kpayTimerRef.current);
      setKpayTimeLeft(60);
      kpayTimerRef.current = setInterval(() => {
        setKpayTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(kpayTimerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else if (type === "ayapay") {
      clearInterval(ayapayTimerRef.current);
      setAyapayTimeLeft(60);
      ayapayTimerRef.current = setInterval(() => {
        setAyapayTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(ayapayTimerRef.current);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  const handlePaymentMethodChange = (method) => {
    setActivePaymentMethod(method);
    if (method === "kpay" || method === "ayapay") {
      startQrTimer(method);
    }
  };

  const handleCardSubmit = (e) => {
    e.preventDefault();
    alert("Payment Sucessful, going to Merchant Portal");
    window.location.href = "https://snmerchant.enrichinsights.com/";
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  const saveQrCode = (type) => {
    const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://${type}.com/pay/desgy-108900-${Date.now()}`;

    //create a temporary anchor element
    const link = document.createElement("a");
    link.href = qrSrc;
    link.download = `${type}_payment-qr_${new Date().getTime()}.png`;

    //append to body, click and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const refreshQrCode = (type) => {
    if (type === "kpay") {
      setKpayTimeLeft(60);
      startQrTimer("kpay");
    } else if (type === "ayapay") {
      setAyapayTimeLeft(60);
      startQrTimer("ayapay");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <div className="py-10"></div>
      <main className="container max-w-5xl mx-auto my-8 px-4 flex-1">
        {/* subscription detail */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden mb-8">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th
                  colSpan="2"
                  className="p-4 text-left bg-gray-50 font-semibold border-b border-gray-200"
                ></th>
              </tr>
            </thead>
            <tbody>
              {subscriptionDetails.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 last:border-b-0"
                >
                  <td className="p-4"> {item.label} </td>
                  <td className="p-4"> {item.label} </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* payment method */}
        <div className="bg-white rounded-xl shadow-md overflow-hidden">
          <div className="p-6">
            <h3 className="text-xl font-semibold mb-4">
              Choose Payment Method
            </h3>
            <div className="flex flex-col md:flex-row gap-4 mb-6">
              {paymentMethods.map((method) => (
                <div
                  key={method.id}
                  className={`flex-1 min-w-[200px] border rounded-lg p-6 cursor-pointer transition-all flex items-center gap-4 ${
                    activePaymentMethod === method.id
                      ? "border-2 border-gray-900 bg-gray-50"
                      : "border-gray-200 hover:border-gray-900 hover:shadow-lg"
                  }`}
                  onClick={() => handlePaymentMethodChange(method.id)}
                >
                  <FontAwesomeIcon
                    icon={method.icon}
                    className="text-2xl text-gray-900"
                  />
                  <div>
                    <h4 className="font-medium"> {method.title} </h4>
                    <p className="text-sm text-gray-600">
                      {" "}
                      {method.description}{" "}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* card payment form */}
            <div
              className={`bg-gray-50 rounded-lg p-8 mt-4 ${
                activePaymentMethod === "card" ? "block" : "hidden"
              }`}
            >
              <form action="" onSubmit={handleCardSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="md:col-span-2 ">
                    <label htmlFor="" className="block mb-2 font-medium">
                      Card Number
                    </label>
                    <input
                      type="text"
                      id="card-number"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
                      placeholder="1234 5678 9012 3456"
                      required
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label htmlFor="" className="block mb-2 font-medium">
                      Cardholder Name
                    </label>
                    <input
                      type="text"
                      id="card-name"
                      className="w-full px-3 py-2 block mb-2 font-medium focus:outline-none focus:ring-2 focus:ring-gray-300

                                        "
                      placeholder="John Doe"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="" className="block mb-2 font-medium">
                      Expiry Date
                    </label>
                    <input
                      type="text"
                      id="expiry"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
                      placeholder="MM/YY"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="" className="block mb-2 font-medium">
                      CVV
                    </label>
                    <input
                      type="text"
                      id="cvv"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
                      placeholder="123"
                      required
                    />
                  </div>
                </div>
                <button className="w-full mt-6 py-4 bg-gray-900 text-white rounded-md font-semibold hover:bg-gray-700 hover:-translate-y-0.5 shadow-md hover:shadow-lg transition-all">
                  Pay MMK 108, 900
                </button>
              </form>
            </div>

            {/* kpay qr code */}
            <div
              className={`bg-gray-50 rounded-lg p-3 mt-4 ${
                activePaymentMethod === "kpay" ? "block" : "hidden"
              }`}
            >
              <div className="text-center p-4 relative">
                <h4 className="text-lg font-medium mb-4">
                  Scan to pay with KPay
                </h4>
                <div className="mb-4">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://kpay.com/pay/shopnest-108900-${Date.now()}`}
                    alt="KPay QR Code"
                    className={`mx-auto ${
                      kpaytimeLeft === 0 ? "opacity-30 grayscale" : ""
                    }`}
                  />
                  <div
                    className={`mt-2 font-semibold ${
                      kpaytimeLeft === 0 ? "text-red-500" : ""
                    }`}
                  >
                    {kpaytimeLeft === 0
                      ? "QR Code Expired"
                      : formatTime(kpaytimeLeft)}
                  </div>
                </div>
                <p className="mb-4">Open Kpay app and scan this QR code</p>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <button
                    onClick={() => saveQrCode("kpay")}
                    className="px-4 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-700 transition-colors"
                  >
                    Save QR Code
                  </button>
                  <button
                    onClick={() => refreshQrCode("kpay")}
                    className="px-4 py-2 bg-white border border-gray-900 text-gray-900 rounded-md hover:bg-gray-50 transition-colors"
                    disabled={kpaytimeLeft === 0}
                  >
                    Refresh
                  </button>
                </div>
              </div>
              <button className="w-full mt-6 py-4 bg-gray-900 text-white rounded-md font-semibold hover:bg-gray-700 hover:-translate-y-0.5 shadow-md hover:shadow-lg transition-all">
                <a
                  href="../merchant_web/app/login/"
                  className="text-white no-underline"
                >
                  Confirm Payment
                </a>
              </button>
            </div>

            {/* aya pay qr code */}
            <div
              className={`bg-gray-50 rounded-lg p-8 mt-4 ${
                activePaymentMethod === "ayapay" ? "block" : "hidden"
              }`}
            >
              <div className="text-center p-4 relative">
                <h4 className="text-lg font-medium mb-4">
                  Scan to pay with AYA pay
                </h4>
                <div className="mb-4">
                  <img
                    src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=https://ayapay.com/pay/shopNest-108900-${Date.now()}`}
                    alt="AYA Pay QR Code"
                    className={`mx-auto ${
                      ayapayTimeLeft === 0 ? "opacity-30 grayscale" : ""
                    }`}
                  />
                  <div
                    className={`mt-2 font-semibold ${
                      ayapayTimeLeft === 0 ? "text-red-500" : ""
                    }`}
                  >
                    {ayapayTimeLeft === 0
                      ? "QR Code Expired"
                      : formatTime(ayapayTimeLeft)}
                  </div>
                </div>
                <div className="mb-4">
                  Open AYA Pay app and scan this QR code
                </div>
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                  <button
                    onClick={() => saveQrCode("ayapay")}
                    className="px-4 py-2 bg-gray-900 text-white rounded-md hover:bg-gray-700 transition-colors"
                    disabled={ayapayTimeLeft === 0}
                  >
                    Save QR Code
                  </button>
                  <button
                    onClick={() => refreshQrCode("ayapay")}
                    className="px-4 py-2 bg-white border border-gray-900 text-gray-900 rounded-md hover:bg-gray-50 transition-colors"
                    disabled={ayapayTimeLeft === 0}
                  >
                    Refresh
                  </button>
                </div>
              </div>
              <button className="w-full mt-6 py-4 bg-gray-900 text-white rounded-md font-semibold hover:bg-gray-700 hover:-translate-y-0.5 shadow-md hover:shadow-lg transition-all">
                Confirm Payment
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentMethod;
